import { createActions } from 'redux-actions';

export const actions = createActions({
  AI_CHAT: {
    SET_OPEN: (isOpen) => isOpen,
    SET_PANEL_WIDTH: (width) => width,
    SET_ACTIVE_VIEW: (view) => view,
    SET_SELECTED_THREAD_ID: (threadId) => threadId,
  },
}).aiChat;
